import { Box, Text } from '@chakra-ui/react'
import { forwardRef } from 'react'

export const Date = forwardRef(({ label, ...rest }, ref) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      gap={2}
      h="37px"
      bgColor="#EDF2F7"
      px={2}
      borderRadius="4px"
      fontSize="12px"
      {...rest}
    >
      <Text>{label}:</Text>
      <input
        type="date"
        ref={ref}
        {...rest}
        style={{
          border: '0',
          padding: '0',
          outline: '0',
          boxShadow: '0',
          height: '100%',
          backgroundColor: 'transparent',
          fontSize: '12px',
        }}
      />
    </Box>
  )
})
